export default "__VITE_ASSET__$2EqOEB$__"